import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IState {
    access_token: string;
    expires_in: number;
    token_type: string;
}

const initialState: IState = {
    access_token: '',
    expires_in: 0,
    token_type: 'bearer',
};

const AdminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        updateToken: (state, action: PayloadAction<any>) => {
            state.access_token = action.payload.access_token;
            state.expires_in = action.payload.expires_in;
        },
    },
});

export const { updateToken } = AdminSlice.actions;
export default AdminSlice.reducer;
